import router from 'next/router';
import React, { useMemo } from 'react';

import { useUserProvider } from '@/context/UserProvider';
import { InsMonitorModel } from '@/types/home';

interface UseLoginAndSubscriptionGuideProps {
  account?: InsMonitorModel;
}

const useLoginAndSubscriptionGuide = ({ account }: UseLoginAndSubscriptionGuideProps = {}) => {
  const { isLogin, onChangedLoginView, onOpenLoginModal, currentLockedAccount } = useUserProvider();

  const innerAccount = useMemo(() => {
    return account || currentLockedAccount;
  }, [account, currentLockedAccount]);

  const planUrl = useMemo(() => {
    if (innerAccount) {
      const search = new URLSearchParams({
        media_name: innerAccount.media_name,
        avatar: innerAccount.avatar,
        media_url: innerAccount.media_url,
      });
      return `/plan?${search.toString()}`;
    }
    return `/plan`;
  }, [innerAccount]);

  const handleClick = (beforeToPlan?: ((planUrl: string, cb?: () => void) => void) | React.MouseEvent) => {
    // 检查是否登录
    if (isLogin) {
      // 引导用户订阅
      if (typeof beforeToPlan === 'function') {
        beforeToPlan(planUrl, () => {
          router.push(planUrl);
        });
      } else {
        router.push(planUrl);
      }
    } else {
      // 引导用户注册/登录
      onChangedLoginView(false);
      onOpenLoginModal(true);
    }
  };

  const checkLogin = () => {
    if (isLogin) {
      return true;
    } else {
      onChangedLoginView(false);
      onOpenLoginModal(true);
      return false;
    }
  };

  return {
    handleLoginAndSubscriptionGuide: handleClick,
    checkLogin,
  };
};

export default useLoginAndSubscriptionGuide;
